<template>
  <div class="dashboard-panel">
    <h3 class="section-title mb-4">
      <svg class="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
      Executive Risk Highlights
    </h3>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
      <div class="text-center p-4 bg-red-50 rounded-xl border border-red-100">
        <p class="text-3xl font-bold text-delayed">{{ highRiskCount }}</p>
        <p class="text-sm text-red-700 font-medium mt-1">High Risk</p>
      </div>
      <div class="text-center p-4 bg-amber-50 rounded-xl border border-amber-100">
        <p class="text-3xl font-bold text-at-risk">{{ delayedCount }}</p>
        <p class="text-sm text-amber-700 font-medium mt-1">Delayed</p>
      </div>
      <div class="text-center p-4 bg-blue-50 rounded-xl border border-blue-100">
        <p class="text-3xl font-bold text-blue-600">{{ risks.length }}</p>
        <p class="text-sm text-blue-700 font-medium mt-1">Total Alerts</p>
      </div>
      <div class="text-center p-4 bg-slate-50 rounded-xl border border-slate-200">
        <p class="text-3xl font-bold text-slate-700">{{ staleCount }}</p>
        <p class="text-sm text-slate-700 font-medium mt-1">Stale Updates</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  risks: { type: Array, default: () => [] }
})

const highRiskCount = computed(() => props.risks.filter(r => r.risk_level === 'High').length)
const delayedCount = computed(() => props.risks.filter(r => r.status === 'Delayed').length)
const staleCount = computed(() => props.risks.filter(r => r.days_since_update && r.days_since_update > 14).length)
</script>
